import React, {useState } from 'react';
import { dateTimeFormat } from '../../utils/Misc/DateTime';
import './CheckmarkWithHover.css';

const ServiceStoppedWithHover = ({ dateStr, ecsIsActive }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    const colorClass = 'hover-label-red'
    const message = `Stop date: ${dateTimeFormat(dateStr)}`
  
    return (
      <>
        <div
          className="checkmark-container stop-label"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {dateStr ? (
            <>
              &nbsp;Stopped
              {isHovered && <div className={colorClass}>{message}</div>}
            </>
          ) : (
            ecsIsActive === "1" && "Stopped"
          )}
        </div>
      </>
    );
};

export default ServiceStoppedWithHover;